{
  "_comment": "[CI-LOCKED] Bu dosyanın içeriği kilitli. Katılımcılar dosyayı kullanabilir ancak değişikliğin doğrulanması gecikebilir.",
  "ACCESS_KEY_ALT": "Alt Shift $1",
  "ACCESS_KEY_FOR_MAC_ALT": "Control Option $1",
  "ACTIVITY_BOT_SAID_ALT": "$1 botu şöyle diyor:",
  "ACTIVITY_STATUS_VOICE_TRANSCRIPT_AGENT_LABEL": "Aracı",
  "ACTIVITY_YOU_SAID_ALT": "Şöyle dediniz:",
  "ACTIVITY_BOT_ATTACHED_ALT": "Bot eklendi:",
  "ACTIVITY_CODE_ALT": "Kod örneği: $1",
  "ACTIVITY_CONTENT_CAUTION": "AI tarafından oluşturulan içerik hatalı olabilir",
  "ACTIVITY_CODE_CAUTION": "AI tarafından oluşturulan kod. Dikkatli şekilde gözden geçirin ve kullanın",
  "ACTIVITY_ERROR_BOX_TITLE": "Hata iletisi",
  "ACTIVITY_INTERACTIVE_FOOTNOTE_ALT": "Etkileşim kurmak için tıklayın.",
  "ACTIVITY_INTERACTIVE_REASON_INTERACTIVE_CONTENT_ALT": "İleti etkileşimli.",
  "ACTIVITY_INTERACTIVE_REASON_LINK_ALT": "İletide bir veya daha fazla bağlantı var.",
  "ACTIVITY_INTERACTIVE_REASON_SEND_FAILED_ALT": "Gönderilemedi.",
  "ACTIVITY_YOU_ATTACHED_ALT": "Şunu eklediniz:",
  "ACTIVITY_NUM_ATTACHMENTS_ONE_ALT": "1 ek.",
  "ACTIVITY_NUM_ATTACHMENTS_FEW_ALT": "$1 ek.",
  "ACTIVITY_NUM_ATTACHMENTS_MANY_ALT": "$1 ek.",
  "ACTIVITY_NUM_ATTACHMENTS_OTHER_ALT": "$1 ekler.",
  "ACTIVITY_NUM_ATTACHMENTS_TWO_ALT": "$1 ek.",
  "ACTIVITY_STATUS_SEND_FAILED_RETRY": "Gönderme başarısız. [Yeniden Dene][RETRY].",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENDING": "Gönderiliyor",
  "ACTIVITY_STATUS_SEND_STATUS_ALT_SENT_AT": "$1 itibarıyla gönderildi",
  "ACTIVITY_STATUS_TIMESTAMP_JUST_NOW": "Hemen şimdi",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_HOUR_AGO": "Bir saat önce",
  "ACTIVITY_STATUS_TIMESTAMP_ONE_MINUTE_AGO": "Bir dakika önce",
  "ACTIVITY_STATUS_TIMESTAMP_TODAY": "Bugün",
  "ACTIVITY_STATUS_TIMESTAMP_YESTERDAY": "Dün",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_PARSE": "Uyarlamalı Kart ayrıştırma hatası",
  "ADAPTIVE_CARD_ERROR_BOX_TITLE_RENDER": "Uyarlamalı Kart işleme hatası",
  "ATTACHMENT_AUDIO": "Ses klibi.",
  "ATTACHMENT_CARD": "Kart: $1 $2 $3",
  "ATTACHMENT_FILE": "Dosya: $1",
  "ATTACHMENT_IMAGE": "Görüntü",
  "ATTACHMENT_TEXT": "Metin: $1",
  "ATTACHMENT_VIDEO": "Video klibi",
  "AVATAR_ALT": "$1 avatar",
  "CAROUSEL_FLIPPER_NEXT_ALT": "Sonraki",
  "CAROUSEL_FLIPPER_PREVIOUS_ALT": "Önceki",
  "CITATION_MODEL_DIALOG_ALT": "Alıntı",
  "CLOSE_BUTTON_ALT": "Kapat",
  "COLLAPSIBLE_GROUPING_TITLE": "Düşünüyorum…",
  "COLLAPSIBLE_GROUPING_TITLE.comment": "Bot bir grupta yanıt iletileri oluştururken bir özet sunulmadığında bu metin gösterilir.",
  "COLLAPSE_BUTTON_LESS": "Daha az göster",
  "COLLAPSE_BUTTON_LESS.comment": "Bu, ileti grubunu daraltmak için kullanılan köşeli çift ayraç düğmesinin metnidir. Son kullanıcı düğmeye tıkladığında ileti grubu daralır.",
  "COLLAPSE_BUTTON_MORE": "Daha fazla göster",
  "COLLAPSE_BUTTON_MORE.comment": "Bu, ileti grubunu genişletmek için kullanılan köşeli çift ayraç düğmesinin metnidir. Son kullanıcı düğmeye tıkladığında ileti grubu genişler.",
  "CONNECTIVITY_STATUS_ALT_CONNECTED": "Bağlı",
  "CONNECTIVITY_STATUS_ALT_CONNECTING": "Bağlantı kuruluyor...",
  "CONNECTIVITY_STATUS_ALT_FATAL": "Bağlantı kurulamadı.",
  "CONNECTIVITY_STATUS_ALT_RECONNECTING": "Ağ kesintisi oluştu. Yeniden bağlanıyor...",
  "CONNECTIVITY_STATUS_ALT_RENDER_ERROR": "İşleme hatası. Lütfen konsolu denetleyin veya bot geliştiricisine başvurun.",
  "CONNECTIVITY_STATUS_ALT_SLOW_CONNECTION": "Bağlantı kurmak normalden uzun sürüyor.",
  "CONNECTIVITY_STATUS_ALT": "Bağlantı Durumu: $1",
  "COPY_BUTTON_TEXT": "Kopyala",
  "COPY_BUTTON_COPIED_TEXT": "Kopyalandı",
  "FEEDBACK_FORM_SUBMIT_BUTTON_LABEL": "Gönder",
  "FEEDBACK_FORM_CANCEL_BUTTON_LABEL": "İptal",
  "FEEDBACK_FORM_PLACEHOLDER": "Mümkün olduğunca fazla ayrıntı verin ancak herhangi özel veya hassas bilgiler eklemeyin.",
  "FEEDBACK_FORM_TITLE": "Bize deneyiminiz hakkında bilgi verin",
  "FILE_CONTENT_ALT": "\"$1\"",
  "FILE_CONTENT_DOWNLOADABLE_ALT": "\"$1\" dosyasını indir",
  "FILE_CONTENT_DOWNLOADABLE_WITH_SIZE_ALT": "$2 boyutlu \"$1\" dosyasını indir",
  "FILE_CONTENT_WITH_SIZE_ALT": "$2 boyutlu \"$1\" dosyası",
  "MARKDOWN_EXTERNAL_LINK_ALT": "Yeni bir pencerede açılır; harici.",
  "RECEIPT_CARD_TAX": "Vergi",
  "RECEIPT_CARD_TOTAL": "Toplam",
  "RECEIPT_CARD_VAT": "KDV",
  "REFERENCE_LIST_HEADER_ONE": "$1 başvuru",
  "REFERENCE_LIST_HEADER_FEW": "$1 başvuru",
  "REFERENCE_LIST_HEADER_MANY": "$1 başvuru",
  "REFERENCE_LIST_HEADER_OTHER": "$1 başvuru",
  "REFERENCE_LIST_HEADER_TWO": "$1 başvuru",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_ALT": "$1 adlı dosyayı sil",
  "SEND_BOX_ATTACHMENT_BAR_DELETE_BUTTON_TOOLTIP": "Sil",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_FILE_ALT": "Bir dosya",
  "SEND_BOX_ATTACHMENT_BAR_GENERIC_IMAGE_ALT": "Bir görüntü",
  "SEND_BOX_IS_EMPTY_TOOLTIP_ALT": "Boş ileti gönderilemez.",
  "SPEECH_INPUT_LISTENING": "Dinliyor…",
  "SPEECH_INPUT_MICROPHONE_BUTTON_CLOSE_ALT": "Mikrofon kapalı",
  "SPEECH_INPUT_MICROPHONE_BUTTON_OPEN_ALT": "Mikrofon açık",
  "SPEECH_INPUT_STARTING": "Başlatılıyor...",
  "SUGGESTED_ACTIONS_FLIPPER_NEXT_ALT": "Sonraki",
  "SUGGESTED_ACTIONS_FLIPPER_PREVIOUS_ALT": "Önceki",
  "SUGGESTED_ACTIONS_LABEL_ALT": "Önerilen eylemler",
  "TEXT_INPUT_ALT": "İleti gelen kutusu",
  "TEXT_INPUT_PLACEHOLDER": "İletinizi yazın",
  "TEXT_INPUT_SPEECH_IDLE_PLACEHOLDER": "Konuşmaya başlayın...",
  "TEXT_INPUT_SPEECH_LISTENING_PLACEHOLDER": "Dinleniyor...",
  "TEXT_INPUT_SPEECH_PROCESSING_PLACEHOLDER": "İşleniyor...",
  "TEXT_INPUT_SPEECH_BOT_SPEAKING_PLACEHOLDER": "Söze girmek için konuşun...",
  "TEXT_INPUT_SEND_BUTTON_ALT": "Gönder",
  "TEXT_INPUT_SPEAK_BUTTON_ALT": "Konuş",
  "TEXT_INPUT_UPLOAD_BUTTON_ALT": "Dosya yükle",
  "TEXT_INPUT_TELEPHONE_KEYPAD_BUTTON_ALT": "Telefon tuş takımı",
  "TEXT_INPUT_DROP_ZONE": "Dosyaları bırak",
  "TEXT_INPUT_LENGTH_EXCEEDED_ALT": "İleti uzunluğu aşıldı",
  "TELEPHONE_KEYPAD_INPUT_MESSAGE": "Yalnızca tek basamaklı girişi destekler",
  "TEXT_INPUT_ATTACHMENTS_FEW": "$1 ek",
  "TEXT_INPUT_ATTACHMENTS_MANY": "$1 ek",
  "TEXT_INPUT_ATTACHMENTS_ONE": "1 ek",
  "TEXT_INPUT_ATTACHMENTS_OTHER": "$1 ek",
  "TEXT_INPUT_ATTACHMENTS_TWO": "$1 ek",
  "TOAST_ACCORDION_FEW": "$1 Bildirim: Ayrıntıları görmek için buraya tıklayın",
  "TOAST_ACCORDION_MANY": "$1 Bildirim: Ayrıntıları görmek için buraya tıklayın",
  "TOAST_ACCORDION_OTHER": "$1 Bildirim: Ayrıntıları görmek için buraya tıklayın",
  "TOAST_ACCORDION_TWO": "$1 Bildirim: Ayrıntıları görmek için buraya tıklayın",
  "TOAST_ALT_ERROR": "Hata",
  "TOAST_ALT_INFO": "Bilgiler",
  "TOAST_ALT_SUCCESS": "Başarılı",
  "TOAST_ALT_WARN": "Uyarı",
  "TOAST_DISMISS_BUTTON": "Kapat",
  "TOAST_TITLE_ALT": "Bildirim",
  "TRANSCRIPT_ARIA_LABEL_ALT": "Sohbet geçmişi, gezinmek için ok tuşlarını kullanın.",
  "TRANSCRIPT_ARIA_ROLE_ALT": "sohbet geçmişi",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_LABEL_ALT": "Mesaj etkileşimlidir. Sohbet geçmişine geçmek için shift sekme tuşuna 2 ila 3 kez basın. Ardından etkileşim kurmak için mesaja tıklayın.",
  "TRANSCRIPT_LIVE_REGION_INTERACTIVE_WITH_LINKS_LABEL_ALT": "Mesajda bir veya daha fazla bağlantı var. Sohbet geçmişine geçmek için shift sekme tuşuna 2 ila 3 kez basın. Ardından etkileşim kurmak için mesaja tıklayın.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_LABEL_ALT": "İletide önerilen eylemler var. Seçmek için Shift + sekme tuşlarına 2-3 kez basın.",
  "TRANSCRIPT_LIVE_REGION_SUGGESTED_ACTIONS_WITH_ACCESS_KEY_LABEL_ALT": "İletide önerilen eylemler var. Seçmek için $1 tuşuna basın.",
  "TRANSCRIPT_LIVE_REGION_SEND_FAILED_ALT": "İleti gönderilemedi.",
  "TRANSCRIPT_LIVE_REGION_NEW_MESSAGES_ALT": "Yeni iletiler var. \"$2\" düğmesine odaklanmak için $1 tuşuna basın.",
  "TRANSCRIPT_MORE_MESSAGES": "Diğer iletiler",
  "TRANSCRIPT_NEW_MESSAGES": "Yeni iletiler",
  "TRANSCRIPT_TERMINATOR_TEXT": "Sohbet geçmişinin sonu",
  "TYPING_INDICATOR_ALT": "Yazma göstergesi gösteriliyor",
  "TYPING_INDICATOR_SINGLE_TEXT": "$1 yazıyor.",
  "TYPING_INDICATOR_MULTIPLE_TEXT": "$1 ve diğer kişiler yazıyor.",
  "VIEW_CODE_BUTTON_TEXT": "Kod",
  "VOTE_COMPLETE_ALT": "Geri bildirim kaydedildi",
  "VOTE_COMPLETE_ALT.comment": "Bu, ekran okuyucu içindir. Başparmak yukarı/aşağı simgeleri olan bir düğmenin etiketi. Etiket, geri bildirim kaydedildiğinde kullanılır.",
  "VOTE_DISLIKE_ALT": "Beğenme",
  "VOTE_LIKE_ALT": "Beğen"
}